<template>
  <div v-observe-visibility="{
         callback: visibilityChanged,
         throttle: 300,
         intersection: {
            threshold: 0.3
          }
         }"
       class="w-full py-8 md:px-0 relative flex items-center"
       style="scroll-snap-align: start"
  >
    <img
        class="picture-hero"
        :class="{'appear':isVisible}"
        v-lazy="picture.path"
        :alt="picture.path"
    />


    <div v-if="picture_index>0"
         class="fixed md:flex md:justify-between w-full p-2 md:p-6 bg-black bottom-0 text-xs font-bold tracking-wider text-primary">


      <a href="#" @click.stop.prevent="goBack" class="md:w-1/3 text-left text-gray-600 hover:text-primary font-light">

        <svg xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" style=" fill:#666;" width="16" height="16"
             viewBox="0 0 26 26" xml:space="preserve" class="inline-block">
          <path d="M26,26H0V0h26V26z" fill="none"></path>
          <g >
            <path d="M15.6,2.6h1.7c0.3,0,0.6,0.2,0.8,0.5S18.2,3.8,18,4l-7.4,9l7.4,9c0.2,0.3,0.3,0.6,0.1,0.9
		c-0.1,0.3-0.4,0.5-0.8,0.5h-1.7c-0.3,0-0.5-0.1-0.7-0.3l-7.8-9.5c-0.3-0.3-0.3-0.8,0-1.1L14.9,3C15.1,2.7,15.3,2.6,15.6,2.6z"/>
          </g>
        </svg>

        {{ from_name === 'home' ? t('back_to_featured_projects') : t('back_to_projects') }}
      </a>


      <div class="md:w-1/3 text-center uppercase">
        {{ t('project') }}: {{ project.title[locale()] }}, {{ t('category') }}: {{ project.category }},
        {{ picture_index }}/{{ pictures_length }}
      </div>
      <div class="md:w-1/3 flex justify-end">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
             class="cursor-pointer"
             @click="goTop()"
             width="26" height="26"
             viewBox="0 0 172 172"
             style=" fill:#000000;">
          <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
             stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none"
             font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
            <path d="M0,172v-172h172v172z" fill="none"></path>
            <g fill="#ffffff">
              <path
                  d="M154.8,103.2v11.46667c0,2.21307 -1.27853,4.2312 -3.27947,5.18293c-2.00093,0.95173 -4.3688,0.65933 -6.0888,-0.74533l-59.43173,-48.63013l-59.43747,48.63013c-1.71427,1.40467 -4.08213,1.69133 -6.0888,0.74533c-2.00667,-0.946 -3.27373,-2.96987 -3.27373,-5.18293v-11.46667c0,-1.72 0.774,-3.34827 2.10413,-4.4376l63.06667,-51.6c2.1156,-1.72573 5.14853,-1.72573 7.26413,0l63.06667,51.6c1.3244,1.08933 2.0984,2.7176 2.0984,4.4376z"></path>
            </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'project-photo-hero',
  props: {
    picture: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    picture_index: {
      type: Number,
      required: true
    },
    pictures_length: {
      type: Number,
      required: true
    },
    from_name: {
      type: String,
      default: 'home'
    }
  },
  data() {
    return {
      isVisible: false
    }
  },
  computed: {},
  methods: {
    goTop() {
      document.getElementById('viewer').scrollTo({top: 0, behavior: 'smooth'});
    },
    goBack() {
      //why length of history is 2????
      window.history.length > 2 ? this.$router.go(-1) : this.$router.push('/')
    },
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible
      if (isVisible) {
        this.$store.commit('setActiveProjectPath', this.picture.path);
      }
    },
  }
}
</script>

<style lang="scss" scoped>

.picture-hero {
  @apply mx-auto py-2;
  width: auto;
  //max-height: 50%;

  transform: scale(.95);
  opacity: 0;
  transition: all 0.5s ease;
  @media only screen and (min-width: 1200px) {
    max-width: 1000px;
  }
}

.appear {
  opacity: 1;
  transform: scale(1);
}

</style>
